var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6812 1.42689C14.529 0.215049 12.6046 0.190774 11.4221 1.37317L2.04729 10.7475C1.71946 11.0754 1.49192 11.4899 1.39136 11.9424L0.513743 15.8923C0.476662 16.0592 0.527421 16.2335 0.64832 16.3544C0.769218 16.4753 0.943496 16.526 1.11038 16.4889L5.03677 15.6157C5.5042 15.5118 5.93231 15.2767 6.2709 14.9381L15.6289 5.58003C16.7699 4.439 16.7931 2.59631 15.6812 1.42689ZM12.1292 2.08029C12.9141 1.29538 14.1916 1.3115 14.9565 2.11596C15.6946 2.89225 15.6792 4.11548 14.9218 4.87293L14.2505 5.54418L11.4579 2.75155L12.1292 2.08029ZM10.7508 3.45864L13.5434 6.2513L5.56379 14.231C5.35964 14.4352 5.10152 14.5769 4.81969 14.6396L1.66038 15.3421L2.36755 12.1593C2.42686 11.8924 2.56104 11.648 2.75438 11.4547L10.7508 3.45864Z",
    fill: "#475569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.16eb7cd057d857f3dba8c05ac468a406.svg";
export { ForwardRef as ReactComponent };